import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache: { [key: string]: { data: any, timestamp: number } } = {};
  private readonly DEFAULT_TTL = 3600000; // 1 hora en milisegundos

  constructor() { }

  /**
   * Guarda datos en la caché con una clave específica
   * @param key Clave para identificar los datos
   * @param data Datos a almacenar
   * @param ttl Tiempo de vida en milisegundos (por defecto 1 hora)
   */
  set(key: string, data: any, ttl: number = this.DEFAULT_TTL): void {
    this.cache[key] = {
      data,
      timestamp: Date.now() + ttl
    };
  }

  /**
   * Obtiene datos de la caché si existen y no han expirado
   * @param key Clave para buscar los datos
   * @returns Los datos almacenados o null si no existen o han expirado
   */
  get(key: string): any | null {
    const item = this.cache[key];
    
    // Si no existe el item o ha expirado
    if (!item || Date.now() > item.timestamp) {
      if (item) {
        // Si existe pero ha expirado, lo eliminamos
        this.remove(key);
      }
      return null;
    }
    
    return item.data;
  }

  /**
   * Elimina un elemento de la caché
   * @param key Clave del elemento a eliminar
   */
  remove(key: string): void {
    delete this.cache[key];
  }

  /**
   * Limpia toda la caché
   */
  clear(): void {
    this.cache = {};
  }

  /**
   * Verifica si un elemento existe en la caché y no ha expirado
   * @param key Clave a verificar
   * @returns true si el elemento existe y no ha expirado
   */
  has(key: string): boolean {
    const item = this.cache[key];
    return !!item && Date.now() <= item.timestamp;
  }
}
